<div
  class="ahe-ui form-group"
  [class.has-feedback]="hasFeedback"
  [class.has-success]="success"
  [class.has-error]="error"
>
  <label *ngIf="label" [attr.for]="id" [class.disabled]="disabled ? 'disabled' : null" [class.sr-only]="hideLabel">
    {{ label }}
    <span class="sr-only" *ngIf="hiddenLabel"> for {{ hiddenLabel }}</span>
    <app-required-indicator [required]="required"></app-required-indicator>
  </label>

  <input
    #input
    class="form-control"
    ngClass="{{ icon ? 'has-icon' : '' }}"
    [type]="type"
    [attr.disabled]="disabled ? '' : null"
    [attr.id]="id"
    [attr.maxlength]="maxlength"
    [attr.placeholder]="placeholder"
    [value]="value"
    (focus)="onTouch($event)"
    (blur)="onBlur($event, input.value)"
    (input)="onInput($event, input.value)"
    [attr.aria-describedby]="inputDescribedBy"
    [attr.aria-invalid]="isInvalid"
    [attr.required]="required ? '' : null"
    autocomplete="on"
  />
  <i *ngIf="icon" class="dpg-icon" ngClass="{{ icon ? 'dpg-icon-' + icon : '' }}" aria-hidden="true"></i>
  <span
    *ngIf="instruction"
    class="input-instruction"
    [attr.id]="'instruction-' + id"
  >
    {{ instruction }}
  </span>
  <span *ngIf="hasFeedback" class="help-block" [attr.id]="helpBlockId">
    <i *ngIf="error" class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <i *ngIf="success" class="dpg-icon dpg-icon-input-success" aria-hidden="true"></i>
    <span>
      <span *ngFor="let message of feedback">{{ message }}<br /></span>
    </span>
  </span>
</div>
